export const GLOBAL_STATE = 'Enrollment'

export const ENROLLMENT = 'enrollment'
export const ENROLLMENT_CREATE = 'enrollmentCreate'
export const ENROLLMENT_COURSES = 'courses'
export const ENROLLMENT_LIST = 'enrollmentList'
export const ENROLLMENT_ALL = 'enrollmentAll'
export const ENROLLMENT_STATUS = 'enrollmentStatus'
